// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-399c3ecb","scoped":true,"hasInlineConfig":false}!./src/components/entry-points/journey-defaults/JourneyDefaults.css
// module id = +MpB
// module chunks = 1